import React, { useState } from 'react';
import { Send, Check, X, AlertCircle } from 'lucide-react';
import { api } from '../config/api';
import './AnswerBox.css';

function AnswerBox({ puzzleSlug, onCorrect, disabled }) {
  const [answer, setAnswer] = useState('');
  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!answer.trim() || loading || disabled) return;

    setLoading(true);
    setFeedback(null);

    try {
      const result = await api.submitGuess(puzzleSlug, answer.trim());
      
      setFeedback({
        type: result.result,
        message: result.message,
        guess: result.guess
      });

      if (result.result === 'correct') {
        onCorrect && onCorrect();
      } else {
        // Clear input on incorrect/partial
        setAnswer('');
      }
    } catch (error) {
      setFeedback({
        type: 'error',
        message: error.message || 'Failed to submit answer'
      });
    } finally {
      setLoading(false);
    }
  };

  const getFeedbackIcon = () => {
    switch (feedback?.type) {
      case 'correct':
        return <Check size={20} />;
      case 'partial':
        return <AlertCircle size={20} />;
      case 'incorrect':
      case 'error':
        return <X size={20} />;
      default:
        return null;
    }
  };

  return (
    <div className="answer-box">
      <form onSubmit={handleSubmit} className="answer-form">
        <input
          type="text"
          value={answer}
          onChange={(e) => setAnswer(e.target.value.toUpperCase())}
          placeholder={disabled ? "SOLVED" : "ENTER YOUR ANSWER"}
          className="answer-input"
          disabled={loading || disabled}
          autoComplete="off"
          spellCheck="false"
        />
        <button 
          type="submit" 
          className="answer-submit"
          disabled={loading || disabled || !answer.trim()}
        >
          {loading ? (
            <span className="spinner small" />
          ) : (
            <Send size={20} />
          )}
        </button>
      </form>

      {feedback && (
        <div className={`answer-feedback ${feedback.type}`}>
          <span className="feedback-icon">{getFeedbackIcon()}</span>
          <span className="feedback-message">{feedback.message}</span>
        </div>
      )}
    </div>
  );
}

export default AnswerBox;
